<template>
  <div>
    <v-list-item dense class="py-1">
      <v-list-item-avatar size="28" class="my-0">
        <v-img :src="avatar_img" />
      </v-list-item-avatar>
      <v-list-item-content class="py-0">
        <v-list-item-title class="text-body-2">
          {{ nome[0] }}
          <span v-if="nome[1]" class="grey--text text-caption"
            >— {{ nome[1] }}</span
          >
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <ColturaEventoElement
      v-for="item in gruppo.items"
      :key="item.id"
      :coltura="item"
      style="padding-left: 40px"
    />
  </div>
</template>

<script>
import ColturaEventoElement from "./coltura_evento_element.vue";

export default {
  name: "ColturaEventoGruppoElement",
  components: { ColturaEventoElement },
  props: {
    // { id_prodotto, items: [ColturaTrattata.to_json(), ...] } — tutte le
    // colture trattate dello stesso prodotto in un evento, raggruppate
    // perché possono provenire da lotti diversi.
    gruppo: Object,
  },
  computed: {
    prodotto() {
      return this.$store.getters.get_prodotto_raw_by_id(this.gruppo.id_prodotto);
    },
    avatar_img() {
      return (
        process.env.VUE_APP_API_ROOT + "/avatar_img/" + this.gruppo.id_prodotto
      );
    },
    nome() {
      return this.prodotto ? this.prodotto.nome.split(" in ") : ["Prodotto"];
    },
  },
};
</script>
